import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export default Wrapper;

export const WrapperSelect = styled.div`
  width: 260px;
`;

export const WrapperOrderBy = styled.div``;
